// services
let services = document.getSelection('.services');

if(services){
    var swiper = new Swiper('.services-swiper', {
        loop: true,
        slidesPerView: 1,
        watchSlidesProgress: true,
        spaceBetween: 30,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 'auto',
                pagination:false,
            },
        },
    });
}